export default class EnrolmentWelcomeViewModel {
    academicYear: string | undefined = undefined;
    studentReferenceNumber: string | undefined = undefined;
    dateofBirth: Date | undefined = new Date(Date.UTC(new Date().getFullYear() - 13, new Date().getMonth(), new Date().getDay()));
    postcode: string | undefined = undefined;
    postcodeIn: string | undefined = undefined;
    postcodeOut: string | undefined = undefined;
}